import { fetchJsonResponse } from '@/ai/api'
import { buildReadModelFromEntityPrompt } from '@/ai/prompts'

export const generateReadModelFromEntity = async ({
  eventId,
  workflow,
  svgGraph,
  svgLanes,
  cardTypes,
  entity,
  abortController
}) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }

  const messages = buildReadModelFromEntityPrompt({
    eventId,
    workflow,
    svgGraph,
    svgLanes,
    cardTypes,
    entity
  })

  try {
    const response = await fetchJsonResponse({
      messages,
      aiVersion: workflow.aiVersion,
      signal: abortController?.signal
    })

    return response || null
  } catch (error) {
    return null
  }
}
